export default __webpack_public_path__ + "static/media/lattes-magazineNC.2f5985b7.svg";